import { render, staticRenderFns } from "./MovingAverageSwitch.vue?vue&type=template&id=d77c78a2&scoped=true&"
import script from "./MovingAverageSwitch.vue?vue&type=script&lang=js&"
export * from "./MovingAverageSwitch.vue?vue&type=script&lang=js&"
import style0 from "./MovingAverageSwitch.vue?vue&type=style&index=0&id=d77c78a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77c78a2",
  null
  
)

export default component.exports